import { createSelector } from '@ngrx/store';

import { AdminState, getAdminState } from '../reducers/admin';

export const getUserAccessListState = createSelector(getAdminState, (state: AdminState) => state?.usersAccess?.list);

export const getInstallerCMSAssociationsState = createSelector(
    getAdminState,
    (state: AdminState) => state?.installers?.cmsAssociations,
);

export const getCurrentUserState = createSelector(getAdminState, (state: AdminState) => state?.currentUser);

export const getCurrentUserCountries = createSelector(
    getAdminState,
    (state: AdminState) => state?.currentUser?.countries,
);

export const getSelectedInstaller = createSelector(getAdminState, (state: AdminState) => state?.selectedInstaller);
